module.exports = __webpack_public_path__ + "assets/img/tieba-code-b86f218c.png";